import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { InputProps, Skeleton } from '@chakra-ui/react';
import { ComboboxItem, ComboboxTagInput } from '@src/components/sco/ComboboxTagInput';
import { gql } from '@src/lib/gql';
import React, { useEffect, useState } from 'react';
export const IndustryAndVerticalTagInput = props => {
  const $ = _c(27);
  let t0;
  if ($[0] !== props.defaultValue) {
    t0 = props.defaultValue || [];
    $[0] = props.defaultValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [preferredIndustriesAndVerticals, setPreferredIndustriesAndVerticals] = useState(t0);
  useState("");
  let t1;
  if ($[2] !== preferredIndustriesAndVerticals || $[3] !== props) {
    t1 = () => {
      props.onChange(preferredIndustriesAndVerticals);
    };
    $[2] = preferredIndustriesAndVerticals;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== preferredIndustriesAndVerticals) {
    t2 = JSON.stringify(preferredIndustriesAndVerticals);
    $[5] = preferredIndustriesAndVerticals;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = [t2];
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t1, t3);
  let t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = gql`
      {
        scoInvestorProfileSearchOptions {
          id
          popularIndustriesAndVerticals
        }
      }
    `;
    t5 = {
      ssr: false
    };
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  const query = useQuery(t4, t5);
  let t6;
  if ($[11] !== query.data?.scoInvestorProfileSearchOptions.popularIndustriesAndVerticals) {
    t6 = query.data?.scoInvestorProfileSearchOptions.popularIndustriesAndVerticals || [];
    $[11] = query.data?.scoInvestorProfileSearchOptions.popularIndustriesAndVerticals;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const options = t6;
  if (query.loading) {
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Skeleton borderRadius="0.25em" height="2.5em" width="full" css={{
        "--start-color": "blackAlpha.300",
        "--end-color": "blackAlpha.500"
      }} />;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    return t7;
  }
  let t7;
  if ($[14] !== props.defaultValue) {
    t7 = props.defaultValue || [];
    $[14] = props.defaultValue;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = t7.map(_temp);
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== props.inputProps) {
    t9 = props.inputProps || {};
    $[18] = props.inputProps;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== options) {
    t10 = options.map(_temp2);
    $[20] = options;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = values => {
      setPreferredIndustriesAndVerticals(values.map(_temp3));
    };
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t8 || $[25] !== t9) {
    t12 = <ComboboxTagInput allowMultipleSelections={true} defaultSelectedItems={t8} inputProps={t9} items={t10} onChange={t11} />;
    $[23] = t10;
    $[24] = t8;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
function _temp(key) {
  return {
    key,
    title: key
  };
}
function _temp2(title) {
  return {
    key: title,
    title
  };
}
function _temp3(v) {
  return v.key;
}